module.exports = __webpack_public_path__ + "img/32.74a11e29.png";